import { Box, BoxProps, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import styles from "./DashboardWidget.module.scss";

type DashboardWidgetProps = {
	title?: string;
} & BoxProps;

const DashboardWidget = ({ title, className, children, ...rest }: DashboardWidgetProps) => {
	return (
		<Box className={clsx(styles.paper, className)} {...rest}>
			{title && <Typography className={styles.title}>{title}</Typography>}
			<Box>{children}</Box>
		</Box>
	);
};

export default observer(DashboardWidget);
